import { render, staticRenderFns } from "./SearchableArtistList.vue?vue&type=template&id=50228e98&scoped=true&"
import script from "./SearchableArtistList.vue?vue&type=script&lang=js&"
export * from "./SearchableArtistList.vue?vue&type=script&lang=js&"
import style0 from "./SearchableArtistList.vue?vue&type=style&index=0&id=50228e98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50228e98",
  null
  
)

export default component.exports